import * as React from "react";
const SvgFlagFrance = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 512 512" {...props}><path d="M0 85.331h512v341.337H0z" style={{
    fill: "#f0f0f0"
  }} /><path d="M0 85.331h170.663v341.337H0z" style={{
    fill: "#0052b4"
  }} /><path d="M341.337 85.331H512v341.337H341.337z" style={{
    fill: "#d80027"
  }} /></svg>;
export default SvgFlagFrance;